import request from '@/api/request'

export default {
  /**
   * Retorna url de etiqueta de envio do pedido.
   *
   * @param identifiers
   * @returns {Promise<void>}
   */
  async getShipmentLabelUrl (identifiers) {
    return (await request.post(`module/action/marketplace/integracommerce/order/shipmentLabelUrl`, identifiers)).data
  },
  /**
   * Retorna lista de atributos do marketplace.
   *
   * @param identifiers
   * @returns {Promise<void>}
   */
  async getAttributes () {
    return (await request.get(`module/action/marketplace/integracommerce/attribute`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/integracommerce/index.js